import conversationCache from './conversationCache';
import deleteConversationItemParts from '../actions/deleteConversationItemParts';
import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type ConversationItemParts from './schema/ConversationItemParts';
import type ConversationReadingPaneNode from './schema/ConversationReadingPaneNode';
import type Folder from './schema/Folder';
import type MailStore from './schema/MailStore';
import type { ConversationTranslation, ItemTranslation } from './schema/MailTranslationViewState';

const mailStoreData: MailStore = {
    attachments: new ObservableMap({}),
    conversationNodes: new ObservableMap<string, ConversationReadingPaneNode>({}),
    conversations: new ObservableMap<string, ConversationItemParts>({}),
    folders: {
        folderTable: new ObservableMap<string, Folder>({}),
        rootFolder: null,
        selectedFolderId: null,
        selectedFocusedViewFilter: null,
    },
    items: new ObservableMap({}),
    mailModule: {
        selectedId: null,
        selectedSubject: null,
        selectedIndex: -1,
    },
    todayDate: null,
    mailTranslations: {
        itemTranslations: new ObservableMap<string, ItemTranslation>({}),
        conversationTranslations: new ObservableMap<string, ConversationTranslation>({}),
    },
};

export const getStore = createStore<MailStore>('mail', mailStoreData);
const store = getStore();

// Cache eviction deletes conversation from mailStore using deleteConversationItemParts
conversationCache.initialize(store.conversations, key => {
    deleteConversationItemParts(key);
});

export default store;
